module.exports = __webpack_public_path__ + "img/HLS-logo.3dffba5f.svg";